import { render, staticRenderFns } from "./Cardlist.vue?vue&type=template&id=36c9097e&scoped=true"
import script from "./Cardlist.vue?vue&type=script&lang=js"
export * from "./Cardlist.vue?vue&type=script&lang=js"
import style0 from "./Cardlist.vue?vue&type=style&index=0&id=36c9097e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9097e",
  null
  
)

export default component.exports